import * as fromSeriousSystem from '@serious-system';
import { neutralizeSpreadsheetFormula } from '@shared';

/**
 * The copy's translation keys, in one place for the eager component and the
 * lazy `chart.copy` module (Article XIV).
 *
 * Each is also what ngx-translate itself returns for a missing key, so an
 * empty resolution falls back to it: illustrative data is never pasted
 * unlabelled (Article IX), and a chart never copies as nothing.
 */
export const ILLUSTRATIVE_KEY = 'CHAT.CHART.ILLUSTRATIVE';
export const COPY_UNAVAILABLE_KEY = 'CHAT.CHART.COPY_UNAVAILABLE';

/**
 * One chart's share of a whole-message copy.
 *
 * `html` holds only escaped strings inside fixed tags; `plain` is markdown;
 * `table` is the copied table, for `table_copied`, or `null` for the notice.
 */
export interface ChartCopyPiece {
  readonly html: string;
  readonly plain: string;
  readonly table: fromSeriousSystem.SdResponseTable | null;
}

/**
 * The "[Chart unavailable]" piece.
 *
 * **Eager, and free of `@shared/charts`**: the copy component
 * builds it when the lazy `chart.copy` chunk fails to load, and the module that
 * failed to load cannot build it. `text` is a resolved
 * translation, never a string from the chart block; it is still neutralized and
 * escaped, as every clipboard string is.
 */
export const chartNoticePiece = (text: string): ChartCopyPiece => ({
  html: `<p>${fromSeriousSystem.escapeHtml(
    neutralizeSpreadsheetFormula(text),
  )}</p>`,
  plain: text,
  table: null,
});
